import { createBrowserRouter, createRoutesFromChildren, Route } from 'react-router-dom';
import { LOGIN, ROOT, USER_MANAGEMENT, AUDIT_LOGS, CONTENT_ITEMS } from 'configs/routeNames';
import { PermissionActions, PermissionSubjects } from 'configs/permissionConstants';
import { AuthorizedElement } from 'app/atoms';
import AppLayout from './AppLayout';
import Pages from './Pages';
import Login from 'app/modules/Auth/Login';
import LandingPage from 'app/pages/LandingPage';
import ContentItemsPage from 'app/pages/ContentItems';
import UserManagementPage from 'app/pages/UserManagement';
import LogsManagementPage from 'app/pages/LogsManagement';
import PageNotFound from 'app/pages/PageNotFound';

export const router = createBrowserRouter(
  createRoutesFromChildren(
    <Route path={ROOT} element={<AppLayout />}>
      <Route path={LOGIN} Component={Login} />
      <Route path={ROOT} Component={Pages}>
        <Route index Component={LandingPage} />
        <Route
          path={CONTENT_ITEMS}
          element={
            <AuthorizedElement
              component={ContentItemsPage}
              requiredPermissions={[{ action: PermissionActions.VIEW, subject: PermissionSubjects.CONTENT_ITEMS }]}
            />
          }
        />
        <Route
          path={USER_MANAGEMENT}
          element={
            <AuthorizedElement
              component={UserManagementPage}
              requiredPermissions={[{ action: PermissionActions.MANAGE, subject: PermissionSubjects.USER_MANAGEMENT }]}
            />
          }
        />
        <Route
          path={AUDIT_LOGS}
          element={
            <AuthorizedElement
              component={LogsManagementPage}
              requiredPermissions={[{ action: PermissionActions.VIEW, subject: PermissionSubjects.ACTIVITY_LOGS }]}
            />
          }
        />
        <Route path="*" Component={PageNotFound} />
      </Route>
    </Route>,
  ),
);
